import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const lunaeldConfig: TSPConfig = {
  key: 'lunaeld',
  name: 'LunaELD',
  category: TSPCategory.CREDENTIALS,
  helpText: 'Please provide your LunaELD credentials.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default lunaeldConfig;
